// PGCET MCA Mock 5 — General English (questions 91–100)
const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Choose the word nearest in meaning to EXACERBATE.",
    options: ["A. Alleviate", "B. Examine", "C. Exaggerate", "D. Aggravate"],
    answer: "D"
  },
  {
    id: 92,
    question: "Choose the antonym of ZENITH.",
    options: ["A. Nadir", "B. Summit", "C. Apex", "D. Pinnacle"],
    answer: "A"
  },
  {
    id: 93,
    question: "Choose the correct meaning of the idiom \"to let the cat out of the bag\".",
    options: [
      "A. To set someone free",
      "B. To cause unnecessary trouble",
      "C. To reveal a secret by mistake",
      "D. To avoid responsibility"
    ],
    answer: "C"
  },
  {
    id: 94,
    question: "Choose the one word for: a person who can speak many languages.",
    options: ["A. Linguist", "B. Polyglot", "C. Bilingual", "D. Orator"],
    answer: "B"
  },
  {
    id: 95,
    question: "Find the part of the sentence that contains an error: The furnitures in this room (A) / are made of (B) / teak wood (C) / No error (D)",
    options: ["A. The furnitures in this room", "B. are made of", "C. teak wood", "D. No error"],
    answer: "A"
  },
  {
    id: 96,
    question: "Choose the correct word to fill the blank: If I ______ you, I would accept the offer.",
    options: ["A. was", "B. am", "C. were", "D. had been"],
    answer: "C"
  },
  {
    id: 97,
    question: "Choose the correct word to fill the blank: He is very fond ______ classical music.",
    options: ["A. with", "B. of", "C. for", "D. about"],
    answer: "B"
  },
  {
    id: 98,
    question: "Which of the following words is spelt correctly?",
    options: ["A. Embarassment", "B. Embarrasment", "C. Embarasment", "D. Embarrassment"],
    answer: "D"
  },
  {
    id: 99,
    question: `Arrange the sentences to form a coherent paragraph:
      P: However, it also raises serious concerns about privacy.
      Q: Artificial intelligence is transforming the way we work and live.
      R: For instance, it powers voice assistants and medical diagnosis tools.
      S: Hence, strong regulation is essential.`,
    options: ["A. QPRS", "B. QRPS", "C. RQPS", "D. QRSP"],
    answer: "B"
  },
  {
    id: 100,
    question: "Read the passage and answer the question: \"Urban trees do far more than beautify a city. They lower surface temperatures, absorb stormwater and filter pollutants from the air. Yet city planners often treat them as mere decoration, cutting them down whenever a road needs widening.\" What is the author's main point?",
    options: [
      "A. Trees should never be cut down under any circumstances",
      "B. Road widening is always unnecessary",
      "C. Urban trees provide practical benefits that planners tend to undervalue",
      "D. Trees in cities are mainly decorative"
    ],
    answer: "C"
  }
];

export default pgcetmcaGeneralEnglish;
